module.exports = __webpack_public_path__ + "static/media/lock.400a4c99.svg";